import { type PropsWithChildren } from 'react';

import { SankeyLayoutContext } from '../context/SankeyLayout.context.js';
import { useGenerateSankeyLayout } from '../hooks/use-generate-sankey-layout.js';

interface SankeyLayoutProviderProps {
  width: number;
  height: number;
}

export const SankeyLayoutProvider = ({
  children,
  width,
  height,
}: Readonly<PropsWithChildren<SankeyLayoutProviderProps>>) => {
  const layout = useGenerateSankeyLayout(width, height);

  return (
    <SankeyLayoutContext.Provider value={layout}>
      {children}
    </SankeyLayoutContext.Provider>
  );
};

SankeyLayoutProvider.displayName = 'SankeyLayoutProvider';
